module.exports = __webpack_public_path__ + "static/social-share-d73a9b23454274d374b05c1b9d40af37.png";